import addDays from "date-fns/addDays";
import isValid from "date-fns/isValid";

export const parseDepartDate = (date) => {
  let departDate;
  if (isValid(new Date(date))) {
    departDate = date;
  } else {
    switch (date) {
      case "today":
        departDate = new Date();
        break;

      case "tomorrow":
        departDate = addDays(new Date(), 1);
        break;

      default:
        departDate = new Date();
    }
  }
  return departDate;
};
